/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Selected_HintInputs */



/**
* | output |
* | --- |
* | "Choose a subtitle preset and export all selected projects." |
*
* @param {Explorer_Info_Batch_Selected_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_selected_hint = /** @type {((inputs?: Explorer_Info_Batch_Selected_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Selected_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un préréglage de sous-titres et exportez tous les projets sélectionnés.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Untertitelvoreinstellung und exportieren Sie alle ausgewählten Projekte.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli un preset per i sottotitoli ed esporta tutti i progetti selezionati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предустановленный набор субтитров и экспортируйте все выбранные проекты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un ajuste preestablecido de subtítulos y exporte todos los proyectos seleccionados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择字幕预设并导出所有选定的项目。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕プリセットを選択し、選択したすべてのプロジェクトをエクスポートします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सबटाइटल प्रीसेट चुनें और सभी चयनित प्रोजेक्ट्स को एक्सपोर्ट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha uma predefinição de legendas e exporte todos os projetos selecionados.")
	return /** @type {LocalizedString} */ ("Choose a subtitle preset and export all selected projects.")
});